export default {
  views: {
    product: {
      description:
        '東京晴空塔展望台入場券和東京索拉玛奇與並設的水族館入場券組合而成的實惠門票。',
      plans: {
        title: '選擇套餐'
      },
      cancelPolicy: {
        title: '取消政策'
      },
      panels: {
        selectDate: '選擇日期',
        selectPlan: '選擇套餐',
        selectPeople: '選擇人數',
        options: '附加商品',
        profile: '個人資料'
      },
      auth: {
        loginOrRegister: '登入 / 註冊',
        signUpTip: '輸入您的資訊以註冊'
      },
      calendar: {
        priceNote: '※顯示價格為當日成人票價'
      },
      recommendations: {
        title: '推薦商品'
      }
    },
    book: {
      title: '訂單確認',
      bookingNotice: '請在預訂前確認',
      paymentConfirmation: '請在支付前確認',
      tip: '請盡快完成操作，以確認訂單'
    },
    bookConfirm: {
      paymentInfo: '付款資訊',
      paymentConfirmation: {
        warningTitle: '請確認取消政策：',
        warningText: '該商品一旦購買將無法退款。',
        agreementText: '我已確認並同意'
      },
      prePaymentConfirmation: {
        title: '付款前確認事項',
        checkInput: '請確認輸入內容是否正確。',
        emailNotice:
          '注意：如果您設置了域名郵件過濾，請在預約前將「@linktivity.co.jp」添加到白名單。',
        agreementText: '我已確認並同意上述事項。'
      },
      paymentAmount: {
        total: '支付金額（含税）',
        details: '詳細',
        note: '日圓以外的幣種金額為依據當前匯率計算的預估金額，與實際扣款金額可能略有差異，僅供參考。'
      },
      participantInfo: {
        title: '代表者資訊',
        dialogTitle: '修改代表者資訊',
        change: '變更',
        password: '密碼',
        validation: {
          passwordRequired: '請輸入密碼'
        }
      },
      actionButtons: {
        back: '返回',
        toPayment: '去付款'
      }
    },
    voucher: {
      pdf: '打印用PDF',
      html: '憑證'
    },
    bookingDetail: {
      title: '預訂詳情',
      detailInfo: '預訂詳情',
      startDate: '參加日期',
      validityPeriod: '有效期',
      voucherInfo: '憑證',
      digitalTicket: '電子票',
      invoice: '收據/發票',
      invoiceSend: '開立',
      invoiceSent: '發票已開立',
      redemption: '使用電子票',
      meetingPoint: '入場位置指南',
      beforeTrip: '使用前確認事項',
      bookingAction: '預訂操作',
      cancelBooking: '取消預訂',
      cancelConfirmPolicy: '請確認取消政策：',
      customerName: '預訂人',
      actualPayment: '付款金額',
      refundAmount: '退款金額',
      orderId: '預訂ID',
      orderCompletionTime: '預訂時間',
      digitalTicketValidPeriod: 'QR碼僅在使用當天有效',
      digitalTicketWaiting: '*訂單確認後，電子票將在此顯示',
      sending: '發送中...',
      sendToEmail: '發送至郵箱',
      cancelConfirm: '是否確認取消訂單？',
      cancelFee: '取消費用',
      cancelRemarkSelect: '請選擇取消原因',
      inclusion: '包含的物品',
      checklist: '注意事項',
      restrictions: '參加限制',
      requirements: '參加前及參加時須知事項',
      attireItems: '參加時所需服裝及攜帶物品',
      otherInfo: '備考・其他',
      attachmentType: {
        ATTACHMENT_TYPE_PDF: 'PDF',
        ATTACHMENT_TYPE_IMAGE: '圖片'
      }
    },
    cancelReason: {
      CANCEL_REASON_OTHER: '其他',
      CANCEL_REASON_MODIFY_BOOKING: '變更預訂日期或人數',
      CANCEL_REASON_BOOKED_BY_MISTAKE: '誤訂',
      CANCEL_REASON_DUPLICATE_BOOKING: '因重複預訂',
      CANCEL_REASON_HEALTH_CONDITION: '生病',
      CANCEL_REASON_TRANSPORTATION_ISSUE: '航班取消、延誤或變更',
      CANCEL_REASON_SCHEDULE_CONFLICT: '行程有變',
      CANCEL_REASON_CHANGE_TO_OTHER_PRODUCT: '改訂為其他商品'
    },
    common: {
      withDashSeparated: '{{val1}} - {{val2}}'
    },
    components: {
      selectOption: {
        title: '附加商品',
        quantity: '數量: {{quantity}}',
        addCart: '加入購物車',
        timeSelect: '選擇時間',
        quantitySelect: '選擇數量',
        quantitySelectLabel: '數量',
        soldOut: '售罄',
        total: '合計'
      },
      planCard: {
        tip: '預定販售當日票'
      },
      planDetailDialog: {
        title: '方案詳情',
        planContent: '方案內容',
        meetingPlace: '集合地點',
        cancellationPolicy: '取消政策'
      },
      priceTableDialog: {
        notes: {
          agePolicy: `５歲以下是免費的，６歲未入學的兒童也是免費的。１５歲以下是學生，適用兒童票價，１８歲以上是高中生，適用青少年票價。`
        }
      },
      payment: {
        ticket: '門票',
        option: '附加商品',
        total: '合計（含稅）',
        details: '詳情',
        submit: '去下單'
      },
      bookingInfo: {
        plan: '套餐',
        dateTime: '日期時間',
        ticket: '門票',
        option: '附加商品',
        discount: '折扣',
        total: '支付金額（含稅）'
      }
    },
    home: {
      title: '東京晴空塔',
      header: {
        alt: '東京晴空塔'
      },
      search: {
        placeholder: '搜尋商品'
      },
      ticketList: {
        title: '票券一覽'
      },
      enjoyPack: {
        title: '暢遊套餐'
      }
    },
    faq: {
      title: '常見問題',
      purchase: {
        title: '購票相關',
        q1: '信用卡無法付款時，該如何處理？',
        a1: `若付款畫面無法順利完成，請依下列項目確認：

1）網路連線狀況

・可能因網路不穩定導致付款中斷。
・請先關閉付款畫面，稍候片刻後，於網路訊號良好的環境下重新操作。

2）信用卡使用狀況與 3D 驗證

・請確認信用卡有效期限及可用額度是否正常。
・請確認信用卡是否已開通「3D 驗證」服務。
・自 2025 年 4 月起，線上購票須使用已設定 3D 驗證之信用卡，系統僅接受符合規定之卡片進行付款。

3）信用卡公司安全機制啟動

・即使信用卡狀態正常，仍可能因發卡銀行啟動安全機制而導致交易失敗。
・建議洽詢您的信用卡發卡銀行確認相關狀況。

如需進一步確認付款狀態，請透過以下表單聯絡客服人員。
https://veltra.zendesk.com/hc/zh-tw/requests/new?ticket_form_id=53455569113241`,
        q2: '欲購買之日期於購票日曆顯示「×」時，該怎麼辦？',
        a2: `＜東京晴空塔 展望台・展望回廊入場券＞
・入場券自使用日前約 2 個月起開放販售，購票日曆將依序開放。
・開賣後，若於購買頁面日曆中無法點選欲購買之日期或時段，表示該場次已售完。建議改選前後其他可預約時段。

▼ 購票頁面請點此
https://global-official-ticket.tokyo-skytree.jp/zt/home

※ 線上購票最晚可購買至使用當日止，惟於大型連假或旺季期間，可能提前售完。
※ 線上購票價格較現場購票優惠，建議提前完成購買。

＜晴空塔 Enjoy Pack＞
・Enjoy Pack 套票自使用日前約 1 個月起開放販售。
・最晚可於使用日前一天完成購買，使用當日恕不提供販售服務。`,
        q3: '門票何時開始販售？',
        a3: `＜東京晴空塔 展望台・展望回廊入場券＞
・入場券自使用日前約 2 個月起開放販售，購票日曆將依序開放。
・即使於使用日前仍可線上購票，惟於大型連假或旺季期間，可能提前售完。

＜晴空塔 Enjoy Pack＞
・Enjoy Pack 套票自使用日前約 1 個月起開放販售。
・最晚可於使用日前一天完成購買，使用當日恕不提供販售服務。

※ 於隅田川煙火大會、元旦等特殊營業日之票券，販售時間可能有所調整，實際開賣資訊將於活動日期接近時，另行於官方網站公告。`,
        q4: '線上購票可使用哪些付款方式？',
        a4: `可使用的付款方式包括信用卡（VISA、MasterCard、AMEX、JCB、Diners）、簽帳金融卡，以及行動支付工具如支付寶（Alipay）與微信支付（WeChat Pay）。`,
        q5: '當日現場是否仍有販售門票？',
        a5: `＜東京晴空塔 展望台・展望回廊入場券＞
・「當日票」未另行保留專屬名額，僅於一般入場券尚有剩餘名額時，方可於事前或當日購買。
・無論線上購票或現場售票，皆以當日仍有庫存為限；若事前已售完之日期，當日將不再追加販售。
・於連續假期或旺季期間，票券可能提前售罄。
・線上購票價格通常較現場購票優惠，建議提前完成購買。
・最新販售狀況請至以下購票頁面查詢。

▼ 購票頁面
https://global-official-ticket.tokyo-skytree.jp/zt/home

＜晴空塔 Enjoy Pack＞
・Enjoy Pack 套票使用當日恕不提供販售，請於預定使用日前一天前完成購買。`,
        q6: '國中畢業至高中入學前期間，應購買哪一種票種？',
        a6: `入場當日未滿 15 歲者適用兒童票，年滿 16 歲（含）以上者適用成人票。`,
        q7: '購票前是否需要註冊會員？',
        a7: `購買 東京晴空塔 門票前，請先完成會員註冊。

▼ 若遇無法登入
請參閱FAQ中的「無法登入帳號，該怎麼辦？」確認內容。`,
        q8: '「ENJOY PACK」是否適用身心障礙者優惠？',
        a8: `「ENJOY PACK」套票已包含優惠折扣，價格已屬優惠方案，恕不再適用身心障礙者相關優惠。`,
        q9: '關於設施、設備及停車場相關資訊',
        a9: `有關設施、設備、停車場、團體預約及團體停車場等相關資訊，請至 東京晴空塔 官方網站「常見問題」頁面查詢。

▼ 東京晴空塔官方網站－設施與設備相關問題
https://www.tokyo-skytree.jp/inquiry/faq.html

▼ 東京晴空塔官方網站－團體預約相關說明
https://www.tokyo-skytree.jp/ticket/group/general/`
      },
      late: {
        title: '可能會趕不上入場時間（遲到）',
        q1: '若預約時段遲到，是否仍可入場？',
        a1: `原則上，請依照購票時所指定之入場時段入場。
如因個人因素導致遲到，僅持有「指定日期與時段票券」之旅客，可於指定當日依現場指示至隊伍尾端排隊入場。
將依現場狀況依序引導入場，惟視當日人潮情況，可能需等候較長時間，敬請見諒。
※本票券僅限指定使用當日有效，逾期恕無法使用，亦不提供退款，敬請留意。

當日營業時間請參考 東京晴空塔 官方網站公告：

▼ 營業時間表
https://www.tokyo-skytree.jp/open-hours/`
      },
      conditions: {
        title: '今日觀景台景色與人潮狀況',
        q1: '當日景觀是否會受天氣影響？',
        a1: `由於展望景觀會隨時間及天候狀況變化，即使聯繫客服中心，亦無法提供即時景觀資訊，敬請見諒。建議事先參考東京地區之氣象預報作為評估依據。
另因雨天、多雲等天氣因素導致視線不佳，恕不提供退費或部分退款服務。

如需取消訂單，請先登入「我的頁面」確認相關取消規定及手續費用後，再行辦理。

▼ 登入我的頁面
https://global-official-ticket.tokyo-skytree.jp/zt/booking`,
        q2: '當日現場人潮狀況如何？',
        a2: `東京晴空塔官方網站首頁提供了人潮預測，供您參考。
・因應現場人潮，搭乘電梯時可能會有等候時間，但即使致電客服中心，也無法提供即時等候狀況，敬請見諒。
建議您預留足夠時間前往。
・展望台入場後，並無停留時間限制，但若當日人潮或電梯運行狀況特殊，可能會由工作人員進行引導，敬請理解。

▼東京晴空塔官方網站 – 混雜預測
https://www.tokyo-skytree.jp/cn_t/ticket/congestion/`
      },
      email: {
        title: '預約完成後，沒有收到郵件通知',
        q1: '預約完成後，沒有收到郵件通知',
        a1: `完成預約後，系統將自動寄送標題為「您的預約已確認（預約編號：ARS_SKYTREE-XXXX-XXXX）」之確認信件至您註冊時填寫的電子郵件信箱，請務必留意查收。

・預約確認信將由「@linktivity.co.jp」網域寄出。
・請同時確認垃圾郵件匣及垃圾郵件資料夾。
・若平時較少使用該電子郵件信箱，亦請確認是否使用其他信箱完成註冊。

如未收到確認信，請先登入會員「我的頁面」確認訂單狀態。

▼ 我的頁面登入
https://global-official-ticket.tokyo-skytree.jp/zt/booking

＊ 若您係透過 東京晴空塔 官方網站以外之線上旅遊平台購票，請直接向原購買平台洽詢相關事宜。

▼ 若遇無法登入
請參閱FAQ中的「無法登入帳號，該怎麼辦？」確認內容。`
      },
      use: {
        title: '門票使用方法',
        q1: '已完成付款，但找不到票券，該怎麼辦？',
        a1: `入場當日所需之憑證（含 QR Code 連結），可於會員「我的頁面」或預約確認信中查詢。

▼ 我的頁面登入
https://global-official-ticket.tokyo-skytree.jp/zt/booking

▼關於預約確認信，請確認以下事項：
・寄件人為「@linktivity.co.jp」。
・信件可能被歸類至垃圾郵件匣或垃圾桶。
・您也可能使用平時較少使用的電子郵件地址進行註冊。
→ 請一併確認是否以其他相關電子郵箱註冊會員，並檢查其收件匣。

▼ 若遇無法登入
請參閱FAQ中的「無法登入帳號，該怎麼辦？」確認內容。

若您係透過 東京晴空塔 官方網站以外之旅遊平台購票，請逕洽原購買平台辦理。
*QR Code 為株式會社 DENSO WAVE 之註冊商標。`,
        q2: '二維條碼無法在手機畫面上顯示，該如何處理？',
        a2: `入場當日所需之憑證連結，可於會員「我的頁面」或預約確認信中查詢。
・若於行動裝置上 QR Code 無法正常顯示，請先關閉畫面，並於網路訊號良好的環境下重新開啟。
・入場時須出示 QR Code，建議事先確認畫面可正常顯示，並可提前截圖備用。

▼ 登入我的頁面
https://global-official-ticket.tokyo-skytree.jp/zt/booking

▼ 若遇無法登入
請參閱FAQ中的「無法登入帳號，該怎麼辦？」確認內容。

若您係透過 東京晴空塔 官方網站以外之線上旅遊平台購票，請直接向原購買平台洽詢。
*QR Code 為株式會社 DENSO WAVE 之註冊商標。`,
        q3: '無法登入帳號，該怎麼辦？',
        a3: `無法登入時，請依下列方式確認：
1）確認登入電子郵件信箱
・請確認是否使用註冊時填寫之正確電子郵件信箱登入。
・若平時較少使用該信箱，亦請嘗試其他可能使用過的信箱。

2）確認登入方式
・請使用與註冊時相同的登入方式。
・若當初使用 Gmail 註冊，請確認當時是透過「Google 登入」或「電子郵件登入」方式註冊。
・如忘記密碼，請於登入頁面點選「忘記密碼」重新設定。

▼ 我的頁面登入
https://global-official-ticket.tokyo-skytree.jp/zt/booking

若您係透過 東京晴空塔 官方網站以外之線上旅遊平台購票，請直接向原購買平台洽詢相關事宜。`,
        q4: '不小心刪除訂票完成確認信，該如何補救？',
        a4: `1）透過「我的頁面」查詢預約資訊
登入「我的頁面」 → 點選右上角人形圖示 → 選擇「我的頁面」→ 點擊「預約資訊」→ 顯示預約列表 → 進入預約詳細頁面，即可查看電子憑證。
▼ 登入我的頁面
https://global-official-ticket.tokyo-skytree.jp/zt/booking

2）透過「我的頁面」重新寄送電子憑證
登入「我的頁面」 → 點選右上角人形圖示 → 選擇「我的頁面」→ 點擊「預約資訊」→ 顯示預約列表 → 進入預約詳細頁面 → 點選「寄送電子憑證」按鈕，即可將含票券連結之電子憑證重新寄送至指定電子郵件信箱。
▼ 登入我的頁面
https://global-official-ticket.tokyo-skytree.jp/zt/booking

若您係透過 東京晴空塔 官方網站以外之線上旅遊平台購票，請直接向原購買平台洽詢相關事宜。`,
        q5: '刪除帳號後無法登入會員頁面，已購買的票券仍可使用嗎？',
        a5: `只要您未操作取消，該筆預約（票券）即屬有效，仍可依原訂內容正常使用。
您可透過預約確認信查詢內含票券連結之電子憑證。`,
        q6: '電子憑證可以列印後攜帶至現場使用嗎？',
        a6: `QR Code 可列印於紙本使用，亦可透過截圖或行動裝置螢幕出示。
列印時，請務必確認 QR Code 清晰可辨，以免影響入場作業。

*QR Code 為株式會社 DENSO WAVE 之註冊商標。`,
        q7: '入場後是否有停留時間限制？',
        a7: `入場後不設停留時間限制。`,
        q8: '可以提前兌換票券嗎？',
        a8: `自 2026 年 3 月 2 日起，票券系統已完成改版，入場時無須另行兌換實體票券。
請於入場時開啟憑證連結，出示畫面上顯示之 QR Code，於入口處掃描後即可進入 東京晴空塔 參觀。
*QR Code 為株式會社 DENSO WAVE 之註冊商標。`,
        q9: '是否可於預約時間前提早入場？',
        a9: `不提供提前入場服務，請依購票時所指定之入場時段入場，敬請配合。`,
        q10: '離場後可以再次入場嗎？',
        a10: `入場後一經離場，恕不提供再次入場服務，敬請留意。`
      },
      changes: {
        title: '門票變更與取消',
        q1: '可以變更入場日期、時間或人數嗎？',
        a1: `非常抱歉，入場日期、時段或人數恕無法變更。
如需調整預約內容，請先取消原訂單後，再依需求重新購票。

・若預約時段將遲到，當日僅限依現場指示至隊伍尾端排隊入場，並可能需等候較長時間。
・取消訂單將依取消政策收取相關費用，請事先於「我的頁面」確認取消規定及手續費。
・為避免作業錯誤，恕不接受透過電話或電子郵件辦理取消。

▼ 我的頁面登入
https://global-official-ticket.tokyo-skytree.jp/zt/booking

本規定適用於 東京晴空塔 相關票券，實際內容請以官方公告為準。`,
        q2: '展望台門票可升級為展望回廊套票嗎？',
        a2: `非常抱歉，購票完成後恕無法升級或更改為展望回廊套票。
如有需求，天望回廊入場券可於地上 350 公尺天望台之現場售票機購買；惟於人潮眾多時，可能視情況暫停販售，敬請見諒。

本規定適用於 東京晴空塔 相關票券，實際販售狀況請以現場公告為準。`,
        q3: '可以取消訂票嗎？',
        a3: `各票種之取消政策可能有所不同，如需取消訂單，請先至「我的頁面」確認相關規定及手續費後，自行完成取消手續。
・取消時，將依規定收取相應之取消費用。
・為避免作業錯誤，恕不受理透過電話或電子郵件提出之取消申請，敬請見諒。

▼ 我的頁面登入
https://global-official-ticket.tokyo-skytree.jp/zt/booking

本規定適用於 東京晴空塔 相關票券，實際內容請以官方公告為準。`,
        q4: '「ENJOY PACK」套票若僅使用其中一項設施，是否可申請退費？',
        a4: `若因個人因素未使用套票內之部分設施，恕不提供退款，敬請留意。`,
        q5: '購買錯誤票種或日期時，該如何處理？',
        a5: `非常抱歉，若您購買之票種、日期或人數有誤，恕無法直接進行變更。如需調整，請先取消原訂單後，再依需求重新購票。
・辦理取消前，請先至「我的頁面」確認相關取消規定及手續費。
・取消作業將依取消政策收取相應之取消費用。
・為避免作業錯誤，恕不受理透過電話或電子郵件提出之取消申請，敬請見諒。

▼ 我的頁面登入
https://global-official-ticket.tokyo-skytree.jp/zt/booking

本規定適用於 東京晴空塔 相關票券，實際內容請以官方公告為準。`,
        q6: '因天災、交通停運或傳染病等不可抗力因素無法前往時，是否可取消訂單？',
        a6: `除非因臨時閉館等特殊狀況外，恕不受理特殊原因之取消申請。相關臨時閉館資訊將公告於 東京晴空塔 官方網站。
・若因交通工具預計停駛等因素需辦理取消，請先至「我的頁面」確認取消政策及相關費用後，自行完成取消手續。
・為避免作業錯誤，恕不受理透過電話辦理取消，敬請見諒。

▼ 我的頁面登入
https://global-official-ticket.tokyo-skytree.jp/zt/booking

▼ 東京晴空塔官方網站
https://www.tokyo-skytree.jp/cn_t/`,
        q7: '遇強風導致電梯停止運轉時，該如何處理？',
        a7: `為確保遊客安全，如遇高空天氣惡化或強風等狀況，觀景台電梯可能視情況暫停運行，敬請見諒。
最新營運資訊請以 東京晴空塔 官方網站公告為準。

關於恢復運行時間及相關退費事宜，請依現場公告為主，並向現場工作人員洽詢。

▼ 東京晴空塔官方網站
https://www.tokyo-skytree.jp/cn_t/`,
        q8: '疑似發生重複扣款時，該如何處理？',
        a8: `請先登入「我的頁面」確認訂單預約狀態。
若僅顯示一筆訂單紀錄，另一筆可能僅為信用卡使用通知，實際尚未完成扣款。

▼ 我的頁面登入
https://global-official-ticket.tokyo-skytree.jp/zt/booking

如需進一步確認付款狀態，請透過以下表單聯絡客服人員。
https://veltra.zendesk.com/hc/zh-tw/requests/new?ticket_form_id=53455569113241
※本說明適用於 東京晴空塔 相關票券之付款與訂單查詢作業，實際處理結果以系統及客服回覆為準。`,
        q9: '系統顯示付款失敗時，該怎麼辦？',
        a9: `請先登入「我的頁面」確認是否已成功完成預約。
若未顯示任何預約資訊，表示訂單尚未成立，請於確認以下事項後重新購票。

▼ 我的頁面登入
https://global-official-ticket.tokyo-skytree.jp/zt/booking

常見原因說明
1）網路連線狀況
・可能因網路短暫不穩定，或同時段訂單量較大，導致連線或付款中斷。
・請先關閉畫面，稍候片刻後，於網路訊號良好的環境下重新操作。

2）信用卡使用狀況與 3D 驗證
・請確認信用卡有效期限及可用額度是否正常。
・請確認信用卡是否已開通「3D 驗證」服務。
・自 2025 年 4 月起，線上購票須啟用 3D 驗證功能，東京晴空塔 官方購票系統僅接受已完成設定之信用卡付款。

3）信用卡公司安全機制
・若信用卡本身無異常仍無法完成付款，可能為發卡銀行啟動安全機制所致。
・建議稍後改用其他信用卡，或洽詢您的發卡銀行確認相關狀況。

如需詳細確認支付及預約狀態，請透過以下表單聯絡客服人員。
https://veltra.zendesk.com/hc/zh-tw/requests/new?ticket_form_id=53455569113241`,
        q10: '已收到信用卡扣款通知，但於「我的訂單」中查無訂單資料，且未收到訂單確認信，該如何處理？',
        a10: `若於「我的頁面」中未顯示預約資訊，可能為以下其中一種情況：

1）使用較少使用的電子郵件信箱註冊
・請確認是否曾使用其他電子郵件信箱註冊。
・請同時檢查各信箱之收件匣及垃圾郵件資料夾，並嘗試登入「我的頁面」查詢。

▼ 我的頁面登入
https://global-official-ticket.tokyo-skytree.jp/zt/booking

2）使用 Google 帳號註冊，但登入方式不一致
・請務必使用與預約時相同之登入方式：
・預約時選擇「Email 登入」者，請使用「Email 登入」。
・預約時選擇「Google 登入」者，請使用「Google 登入」。

3）付款或預約未完成
・雖已進行信用卡額度驗證，但可能因網路不穩定等因素，導致付款或預約程序未成功完成。
・請確認信用卡帳單是否實際產生扣款紀錄。

如需詳細確認支付及預約狀態，請透過以下表單聯絡客服人員。
https://veltra.zendesk.com/hc/zh-tw/requests/new?ticket_form_id=53455569113241`,
        q11: '取消訂單後，退款約於何時入帳？',
        a11: `若已完成取消手續但尚未收到退款，可能因信用卡公司作業流程需時處理，建議先向發卡銀行確認入帳狀況。

如需進一步查詢退款進度，請透過以下表單聯絡客服人員。
https://veltra.zendesk.com/hc/zh-tw/requests/new?ticket_form_id=53455569113241

本說明適用於 東京晴空塔 相關票券之退費作業規範，實際處理情形請以系統及客服回覆為準。`,
        q12: '是否可開立發票？',
        a12: `1）透過 東京晴空塔 官方網站購票
・發票可於「我的頁面」或預約確認郵件中點選「發票」按鈕自行開立。
・開立後，系統將由 linktivity.co.jp 寄送「發票發送通知」電子郵件，請同時檢查垃圾郵件或垃圾桶資料夾。
▼ 我的頁面登入
https://global-official-ticket.tokyo-skytree.jp/zt/booking


2）團體預約
・請參考以下專用頁面辦理相關發票事宜：
▼ 東京晴空塔官方網站 – 團體預約頁面
https://www.tokyo-skytree.jp/ticket/group/general/

3）當日現場購票
・無法線上開立發票，請至現場窗口洽詢相關作業。
▼ 東京晴空塔官方網站
https://www.tokyo-skytree.jp/cn_t/`
      },
      payment: {
        title: '付款相關問題',
        q1: '疑似發生重複扣款時，該如何處理？',
        a1: `請先登入「我的頁面」確認訂單預約狀態。
若僅顯示一筆訂單紀錄，另一筆可能僅為信用卡使用通知，實際尚未完成扣款。

▼ 我的頁面登入
https://global-official-ticket.tokyo-skytree.jp/zt/booking

如需進一步確認付款狀態，請透過以下表單聯絡客服人員。
https://veltra.zendesk.com/hc/zh-tw/requests/new?ticket_form_id=53455569113241
※本說明適用於 東京晴空塔 相關票券之付款與訂單查詢作業，實際處理結果以系統及客服回覆為準。`,
        q2: '系統顯示付款失敗時，該怎麼辦？',
        a2: `請先登入「我的頁面」確認是否已成功完成預約。
若未顯示任何預約資訊，表示訂單尚未成立，請於確認以下事項後重新購票。

▼ 我的頁面登入
https://global-official-ticket.tokyo-skytree.jp/zt/booking

常見原因說明
1）網路連線狀況
・可能因網路短暫不穩定，或同時段訂單量較大，導致連線或付款中斷。
・請先關閉畫面，稍候片刻後，於網路訊號良好的環境下重新操作。

2）信用卡使用狀況與 3D 驗證
・請確認信用卡有效期限及可用額度是否正常。
・請確認信用卡是否已開通「3D 驗證」服務。
・自 2025 年 4 月起，線上購票須啟用 3D 驗證功能，東京晴空塔 官方購票系統僅接受已完成設定之信用卡付款。

3）信用卡公司安全機制
・若信用卡本身無異常仍無法完成付款，可能為發卡銀行啟動安全機制所致。
・建議稍後改用其他信用卡，或洽詢您的發卡銀行確認相關狀況。

如需詳細確認支付及預約狀態，請透過以下表單聯絡客服人員。
https://veltra.zendesk.com/hc/zh-tw/requests/new?ticket_form_id=53455569113241
`,
        q3: '已收到信用卡扣款通知，但於「我的訂單」中查無訂單資料，且未收到訂單確認信，該如何處理？',
        a3: `若於「我的頁面」中未顯示預約資訊，可能為以下其中一種情況：

1）使用較少使用的電子郵件信箱註冊
・請確認是否曾使用其他電子郵件信箱註冊。
・請同時檢查各信箱之收件匣及垃圾郵件資料夾，並嘗試登入「我的頁面」查詢。

▼ 我的頁面登入
https://global-official-ticket.tokyo-skytree.jp/zt/booking

2）使用 Google 帳號註冊，但登入方式不一致
・請務必使用與預約時相同之登入方式：
・預約時選擇「Email 登入」者，請使用「Email 登入」。
・預約時選擇「Google 登入」者，請使用「Google 登入」。

3）付款或預約未完成
・雖已進行信用卡額度驗證，但可能因網路不穩定等因素，導致付款或預約程序未成功完成。
・請確認信用卡帳單是否實際產生扣款紀錄。

如需詳細確認支付及預約狀態，請透過以下表單聯絡客服人員。
https://veltra.zendesk.com/hc/zh-tw/requests/new?ticket_form_id=53455569113241
`,
        q4: '取消訂單後，退款約於何時入帳？',
        a4: `若已完成取消手續但尚未收到退款，可能因信用卡公司作業流程需時處理，建議先向發卡銀行確認入帳狀況。
如需進一步查詢退款進度，請透過以下表單聯絡客服人員。
https://veltra.zendesk.com/hc/zh-tw/requests/new?ticket_form_id=53455569113241
本說明適用於 東京晴空塔 相關票券之退費作業規範，實際處理情形請以系統及客服回覆為準。`,
        q5: '是否可開立發票？',
        a5: `1）透過 東京晴空塔 官方網站購票
・發票可於「我的頁面」或預約確認郵件中點選「發票」按鈕自行開立。
・開立後，系統將由 linktivity.co.jp 寄送「發票發送通知」電子郵件，請同時檢查垃圾郵件或垃圾桶資料夾。
▼ 我的頁面登入
https://global-official-ticket.tokyo-skytree.jp/zt/booking


2）團體預約
・請參考以下專用頁面辦理相關發票事宜：
▼ 東京晴空塔官方網站 – 團體預約頁面
https://www.tokyo-skytree.jp/ticket/group/general/

3）當日現場購票
・無法線上開立發票，請至現場窗口洽詢相關作業。
▼ 東京晴空塔官方網站
https://www.tokyo-skytree.jp/cn_t/`
      },
      disabilities: {
        title: '身心障礙人士及陪同服務說明',
        q1: '身心障礙人士及陪同服務說明',
        a1: `適用條件

持有身心障礙者手冊者及其陪同者可適用身心障礙者票價。
陪同者票券可購買與手冊持有者相同人數。
入場時需出示身心障礙者手冊，請務必攜帶。


通常票價的變更
如以通常票價購買票券，無法變更至身心障礙者票價。
如需變更，請先取消當前預約，再重新購買所需票券。
▼ 取消方法請參考此處
https://global-official-ticket.tokyo-skytree.jp/zt/booking`
      },
      group: {
        title: '團體預約相關',
        q1: '團體預約相關',
        a1: `團體預約請透過 東京晴空塔 專用窗口辦理。
請至官方網站「聯絡我們」頁面，查閱「聯絡方式一覽」以取得詳細資訊。

▼ 東京晴空塔官方網站 – 團體預約專用窗口
https://www.tokyo-skytree.jp/inquiry/`
      },
      tips: `客服信箱：<a href="mailto:helpcenter@linktivity.co.jp" rel="noreferrer">helpcenter@linktivity.co.jp</a>
關於線上購買的電話諮詢：<a href="tel:+81368217196">+81-3-6821-7196</a>
※來電諮詢時，將先由自動語音系統提供說明，並依據您的諮詢內容轉接至適當的客服人員。
※撥打電話將依電信業者規定收取通話費。
客服人員服務時間：10:00～19:00`
    }
  }
};
